"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function default_1(isPreview) {
    const rootDiv = document.getElementById('root');
    (0, react_1.useEffect)(() => {
        if (isPreview) {
            rootDiv.style.maxWidth = '800px';
        }
        else {
            rootDiv.style.removeProperty('max-width');
        }
    }, [isPreview]);
}
exports.default = default_1;
